import script from "./AttributeDropdown.vue?vue&type=script&setup=true&lang=js"
export * from "./AttributeDropdown.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__